import React, { useEffect } from "react";
import { initQZTray } from "../../services/print-sevice/qz-setup";

/**
 * This component should be used other places and everything should be done inside it or its child component but recommended not pass any data to its invoked page or component
 *
 * @param {*} shouldFindPrinter values USB, Bluetooth, TCP, No
 * @returns
 */
export default function QzTrayInitComponent({ }) {
  useEffect(() => {
    (async () => {
      console.log("-------Before initialization of QZ tray-----");

      await initQZTray();

      console.log("-------After---initialization of QZ tray-----");
    })();
  }, []);
  
  return <div></div>;
}
